export const getReferenceColumn = (handleChangeValue) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.name || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Employee Code",
    dataIndex: "employee_code",
    key: "employee_code",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.employee_code || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Work Location",
    dataIndex: "work_location",
    key: "work_location",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.work_location || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  // {
  //   title: "Relationship",
  //   dataIndex: "relationship",
  //   key: "relationship",
  //   type: "select",
  //   selectOptions: [
  //     { label: "Single", value: "single" },
  //     { label: "Married", value: "married" },
  //   ],
  //   valuePath: (record, output) => output?.[record.label]?.relationship || "",
  //   onChange: (val, dataIndex, record) =>
  //     handleChangeValue(val, dataIndex, record.label),
  // },
  {
    title: "Company Name",
    dataIndex: "company_name",
    key: "company_name",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.company_name || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Contact Number",
    dataIndex: "contact_number",
    key: "contact_number",
    inputType: "number",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.contact_number || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
];

export const getColumnsConfig = (handleChangeValue) => [
  {
    title: "Organization Name",
    dataIndex: "organization_name",
    key: "organization_name",
    type: "input",
    valuePath: (record, output) =>
      output?.[record.label]?.organization_name || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Designation",
    dataIndex: "designation",
    key: "designation",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.designation || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Duration (From-To)",
    dataIndex: "duration",
    key: "duration",
    type: "dateRange",
    valuePath: (record, output) => output?.[record.label]?.duration || [],
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Reason For Leaving",
    dataIndex: "reason_for_leaving",
    key: "reason_for_leaving",
    type: "textarea",
    valuePath: (record, output) =>
      output?.[record.label]?.reason_for_leaving || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
];

export const getFamilyColumnsConfig = (handleChangeValue, relationshipdrop) => [
  {
    title: "Relationship",
    dataIndex: "relationship",
    key: "relationship",
    type: "text",
    selectOptions: relationshipdrop,
    valuePath: (record, output) => output?.[record.label]?.relationship || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.name || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },

  {
    title: "DOB",
    dataIndex: "dob",
    key: "dob",
    type: "datePicker",
    valuePath: (record, output) => output?.[record.label]?.dob || [],
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Nationality",
    dataIndex: "nationality",
    key: "nationality",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.nationality || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Occupation",
    dataIndex: "occupation",
    key: "occupation",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.occupation || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
];

export const getEduColumnsConfig = (handleChangeValue) => [
  {
    title: "Qualification",
    dataIndex: "qualification",
    key: "qualification",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.qualification || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Stream",
    dataIndex: "stream",
    key: "stream",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.stream || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "University/Institue",
    dataIndex: "board",
    key: "board",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.board || [],
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Year of Passing",
    dataIndex: "year_of_passing",
    key: "year_of_passing",
    type: "input",
    valuePath: (record, output) =>
      output?.[record.label]?.year_of_passing || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Grade/CGPA",
    dataIndex: "grade_cgpa",
    key: "grade_cgpa",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.grade_cgpa || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
];

export const getNomineeColumnsConfig = (
  handleChangeValue,
  relationshipdrop
) => [
  {
    title: "Nominee's Name",
    dataIndex: "full_name",
    key: "full_name",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.full_name || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Relationship with Nominee",
    dataIndex: "relationship",
    key: "relationship",
    type: "select",
    selectOptions: relationshipdrop,
    valuePath: (record, output) => output?.[record.label]?.relationship || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Nominee's DOB",
    dataIndex: "dob",
    key: "dob",
    type: "datePicker",
    valuePath: (record, output) => output?.[record.label]?.dob || [],
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Nominee's Aadhar Number",
    dataIndex: "aadhar_number",
    key: "aadhar_number",
    type: "input",
    valuePath: (record, output) => output?.[record.label]?.aadhar_number || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
  {
    title: "Share of Nominee(%)",
    dataIndex: "share_percentage",
    key: "share_percentage",
    type: "input",
    valuePath: (record, output) =>
      output?.[record.label]?.share_percentage || "",
    onChange: (val, dataIndex, record) =>
      handleChangeValue(val, dataIndex, record.label),
  },
];
